import { z } from "zod";

export const freelancerDetailsFormSchema = z.object({
    service: z.string("Primary Service is required").min(1, 'Please select a primary service.'),
    role: z.string("Role is required").min(1, 'Please select a role.'),
    budget: z.number("Minimum Project Budget is required").positive('Please select a minimum project budget.'),
});

export const agencyDetailsFormSchema = z.object({
    service: z.string("Primary Service is required").min(1, 'Please select a primary service.'),
    budget: z.number("Minimum Project Budget is required").positive('Please select a minimum project budget.'),
    partnerLink: z.string().optional(),
    shopifyTier: z.string().optional(),
    appTier: z.boolean().optional(),
});

export type FreelancerDetailsFormSchema = z.infer<typeof freelancerDetailsFormSchema>;
export type AgencyDetailsFormSchema = z.infer<typeof agencyDetailsFormSchema>;
